import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { BuildstuffApp } from './components/BuildstuffApp';
import { ArchitectureDiagram } from './components/ArchitectureDiagram';
import { ProjectStructure } from './components/ProjectStructure';
import { OrkWayApp } from './components/OrkWayApp';
import PousadaInternetPM from './components/PousadaInternetPM';
import PhraseMakerApp from './components/PhraseMakerApp';
import PastTenseTrainerApp from './components/PastTenseTrainerApp';
import StorytellingTrainerApp from './components/StorytellingTrainerApp';

function App() {
  return (
    <Routes>
      <Route path="/" element={<BuildstuffApp />} />
      <Route path="/orkway" element={<OrkWayApp />} />
      <Route path="/pousada" element={<PousadaInternetPM />} />
      <Route path="/frases" element={<PhraseMakerApp />} />
      <Route path="/past-tense" element={<PastTenseTrainerApp />} />
      <Route path="/storytelling" element={<StorytellingTrainerApp />} />
      <Route path="/architecture" element={<ArchitectureDiagram />} />
      <Route path="/structure" element={<ProjectStructure />} />
    </Routes>
  );
}

export default App;
